import api from '@/apis/di/accountingObjectAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('staticReportPrint', api);

const state = {
  ...crud.state,
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  loading(context, payload) {
    context.commit('updateLoading', true);
  },

  unloading(context, payload) {
    context.commit('updateLoading', false);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
